import { useSearchParams } from 'next/navigation';

import { useAppRouter } from '@/hooks/useAppRouter';

export function useRedirectUrl() {
  const router = useAppRouter();
  const searchParams = useSearchParams();

  const redirectUrlEncoded = searchParams?.get('redirectURL') || undefined;
  const redirectUrl = redirectUrlEncoded ? decodeURIComponent(redirectUrlEncoded) : undefined;

  const buildUrlWithRedirect = (pathname: string, additionalQuery: Record<string, any> = {}) => {
    const redirectParam = redirectUrlEncoded ? { redirectURL: redirectUrlEncoded } : {};
    return {
      pathname,
      query: {
        ...redirectParam,
        ...additionalQuery,
      },
    };
  };

   const buildFullURL = (pathname: string, additionalQuery: Record<string, any> = {}) => {
    const url = buildUrlWithRedirect(pathname, additionalQuery);
    const urlSearchParams = new URLSearchParams(url.query as Record<string, string>);
    const queryString = urlSearchParams.toString();
    const fullUrl = queryString ? `${url.pathname}?${queryString}` : url.pathname;
    return fullUrl;
  };

  const pushWithRedirect = (pathname: string, additionalQuery: Record<string, any> = {}) => {
    const fullUrl = buildFullURL(pathname, additionalQuery);
    router.push(fullUrl);
};

  return {
    redirectUrl,
    buildUrlWithRedirect,
    buildFullURL,
    pushWithRedirect,
  };
}
